/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { DependencyList, useEffect } from "react";
import { useAsyncRetry } from "react-use";

export const useCallApi = <T>(
  func: () => Promise<T>,
  cancel: () => void,
  deps?: DependencyList
) => {
  useEffect(() => {
    return () => {
      cancel();
    };
  }, [cancel]);
  return useAsyncRetry(async () => {
    try {
      return await func();
    } catch (err) {
      if (err instanceof DOMException && err.name === "AbortError") {
        // Ignore abort errors
        console.debug("ignore");
        return undefined;
      }
      console.error(err);
      throw err;
    }
  }, deps);
};
